var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-100"},[_c('p',{attrs:{"id":"titulo-topo-pagina"}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.titulo))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }